import type { BrowserLogger } from './browser-logger';

/** Routes uncaught exceptions and unhandled promise rejections into diagnostics as WEB-RUNTIME-001. */
export function installGlobalErrorHandlers(
  logger: BrowserLogger,
  target: Window = window,
): () => void {
  const onError = (event: ErrorEvent) => {
    logger.error('web-runtime', 'Uncaught exception', {
      code: 'WEB-RUNTIME-001',
      origin: 'apps/web/src/diagnostics/global-handlers.ts:onError',
      context: {
        errorName: event.error instanceof Error ? event.error.name : 'Error',
        detail: event.message,
        fileName: event.filename,
        line: event.lineno,
      },
    });
  };
  const onRejection = (event: PromiseRejectionEvent) => {
    const reason: unknown = event.reason;
    logger.error('web-runtime', 'Unhandled promise rejection', {
      code: 'WEB-RUNTIME-001',
      origin: 'apps/web/src/diagnostics/global-handlers.ts:onRejection',
      context: {
        errorName: reason instanceof Error ? reason.name : typeof reason,
        detail: reason instanceof Error ? reason.message : String(reason),
      },
    });
  };
  target.addEventListener('error', onError);
  target.addEventListener('unhandledrejection', onRejection);
  return () => {
    target.removeEventListener('error', onError);
    target.removeEventListener('unhandledrejection', onRejection);
  };
}
